import {PaymentMessagingElement} from "./PaymentMessagingElement";

window.customElements.define("stripe-messaging", PaymentMessagingElement);